import { toClass } from 'class-converter';
import DeclarationVente from 'mpm-classes/DeclarationVente';
import Components from 'mpm-components';
import * as Constants from 'mpm-config/Constants';
import Services from 'mpm-services';
import React from 'react';
import { Button, Divider, Icon, Step } from 'semantic-ui-react';
import StepDetails from './sections/StepDetails';
import StepRecap from './sections/StepRecap';
import StepSources from './sections/StepSources';

export default ({ selectedDeclarationVenteId, onComplet, setMessage, entities, pays, typesTransformations, onClickDelete }) => {
  const [declarationVente, setDeclarationVente] = React.useState(toClass({}, DeclarationVente));
  const [loading, setLoading] = React.useState(true);
  const [isError, setIsError] = React.useState(false);
  const [step, setStep] = React.useState(1);
  const [saving, setSaving] = React.useState(false);
  const [validating, setValidating] = React.useState(false);
  const [updateMode, setUpdateMode] = React.useState(false);

  React.useEffect(() => {
    if (!selectedDeclarationVenteId) {
      setDeclarationVente(toClass({}, DeclarationVente));
      setLoading(false);
    } else {
      Services.DeclarationVenteService.findForEdit(selectedDeclarationVenteId)
        .then((response) => {
          setDeclarationVente(
            toClass(
              {
                ...response.data,
              },
              DeclarationVente
            )
          );
          setLoading(false);
          setIsError(false);
          setUpdateMode(true);
        })
        .catch((err) => {
          setIsError(true);
          setLoading(false);
          setUpdateMode(false);
        });
    }
  }, [selectedDeclarationVenteId]);

  const onClickNext = () => {
    setStep(step + 1);
    setMessage(null);
  };
  const onClickPrevious = () => {
    setStep(step - 1);
    setMessage(null);
  };

  const onSave = () => {
    setSaving(true);
    let toBeSaved = toClass(
      {
        ...declarationVente,
      },
      DeclarationVente
    );
    Services.DeclarationVenteService.create({ ...toBeSaved })
      .then((result) => {
        if (result.success) {
          setDeclarationVente(toClass({ ...declarationVente, ...result.data }, DeclarationVente));
          setUpdateMode(true);
          setSaving(false);
          setMessage({
            success: true,
            header: 'Enregistrement déclaration de vente',
            content: 'Votre déclaration a été enregistré avec succée!',
          });
          onComplet(true, {
            numeroVisa: result.data.numeroVisa,
            etat: result.data.etat,
            numeroDV: result.data.numeroDV,
          });
        } else {
          setMessage({
            warning: true,
            header: 'Enregistrement déclaration de vente',
            content: result.message,
          });
          setSaving(false);
        }
      })
      .catch((error) => {
        setMessage({
          error: true,
          header: 'Enregistrement déclaration de vente',
          content: "Une erreur est survenue lors d'enregistrement de cession d'exportation",
        });
        setSaving(false);
      });
  };

  const onValidate = () => {
    let data = {
      ...declarationVente,
    };
    setValidating(true);
    Services.DeclarationVenteService.validate(data)
      .then((result) => {
        if (result.success) {
          setDeclarationVente(toClass({ ...declarationVente, etat: result.data.etat }, DeclarationVente));
          setUpdateMode(true);
          setMessage({
            success: true,
            header: 'Validation déclaration de vente',
            content: 'Votre déclaration a été validé avec succée',
          });
          setValidating(false);
          onComplet(true, {
            numeroVisa: result.data.numeroVisa,
            etat: result.data.etat,
            numeroDV: result.data.numeroDV,
          });
        } else {
          setMessage({
            error: true,
            header: 'Validation déclaration de vente',
            content: result.message,
          });
          setValidating(false);
        }
      })
      .catch((error) => {
        setMessage({
          error: true,
          header: 'Validation déclaration de vente',
          content: "Une erreur est survenue lors de validation de cession d'exportation",
        });
        setValidating(false);
      });
  };

  const isDisabledButtonNext = () => {
    if (step === 1) {
      return step === 1 && declarationVente.existingChildrenSrcEspeceDV.length < 1;
    } else if (step === 2) {
      return step === 2 && declarationVente.childrenSrcEspeceDV.length < 1;
    } else {
      return step === 3;
    }
  };

  return loading ? (
    <Components.MPMLoader message="chargement en cours, veuillez patienter !" hideLogo />
  ) : isError ? (
    <Components.MPMError />
  ) : (
    <>
      <Step.Group ordered fluid size="small" unstackable={true}>
        <Step active={step === 1} completed={step > 1} disabled={step < 1}>
          <Step.Content>
            <Step.Title>Déclaration de vente</Step.Title>
          </Step.Content>
        </Step>
        <Step active={step === 2} completed={step > 2} disabled={step < 2}>
          <Step.Content>
            <Step.Title>Especes</Step.Title>
          </Step.Content>
        </Step>
        <Step active={step === 3} completed={step > 3} disabled={step < 3}>
          <Step.Content>
            <Step.Title>Récapitulatif</Step.Title>
          </Step.Content>
        </Step>
      </Step.Group>

      {step === 1 && <StepDetails editMode={true} entities={entities} pays={pays} typesTransformations={typesTransformations} declarationVente={declarationVente} setMessage={(data) => setMessage(data)} setDeclarationVente={(result) => setDeclarationVente(result)} />}
      {step === 2 && <StepSources editMode={true} entities={entities} pays={pays} typesTransformations={typesTransformations} declarationVente={declarationVente} onComplet={(force) => onComplet(force)} setMessage={(data) => setMessage(data)} setDeclarationVente={(result) => setDeclarationVente(result)} onClickDelete={(dd) => onClickDelete(dd)} updateMode={updateMode} />}
      {step === 3 && <StepRecap editMode={true} entities={entities} pays={pays} typesTransformations={typesTransformations} declarationVente={declarationVente} setMessage={(data) => setMessage(data)} setDeclarationVente={(result) => setDeclarationVente(result)} />}

      <Divider />
      <Button icon className="full-width" labelPosition="left" onClick={() => onComplet()} size="tiny" disabled={saving || validating}>
        <Icon name="arrow left" />
        Retour
      </Button>
      {declarationVente.etat !== Constants.CC_ETAT_VALIDER && (
        <>
          <Button icon className="full-width" labelPosition="left" onClick={() => onSave()} loading={saving} primary size="tiny" disabled={step !== 3 || saving || validating}>
            <Icon name="save" />
            Enregitrer
          </Button>
          <Button icon className="full-width" labelPosition="left" onClick={() => onValidate()} loading={validating} positive size="tiny" disabled={step !== 3 || saving || validating}>
            <Icon name="check" />
            Valider
          </Button>
        </>
      )}
      <Button icon className="full-width" labelPosition="right" onClick={() => onClickNext()} disabled={isDisabledButtonNext()} size="tiny" floated="right">
        <Icon name="chevron right" />
        Suivant
      </Button>
      <Button icon className="full-width" labelPosition="left" onClick={() => onClickPrevious()} disabled={step === 1 ? true : false} size="tiny" floated="right">
        <Icon name="chevron left" />
        Précédent
      </Button>
    </>
  );
};
